import Header from '../Header/Header'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../contexts/authContext'

const pastels = [
  ['#FBE3D2', '#9A5B2B'], ['#E4EFE0', '#4A7A54'], ['#E7E4F4', '#5E568F'],
  ['#FDF0D3', '#94742A'], ['#DFEDF3', '#3E6E85'], ['#F6E0E6', '#9A4E67'],
]
const names = [
  ['Emma', 'Noah'], ['Olivia', 'Liam'], ['Nora', 'Jakob'], ['Ella', 'Lucas'],
  ['Sofie', 'Filip'], ['Maja', 'Oskar'], ['Frida', 'Aksel'], ['Ingrid', 'Theo'],
]

export default function Hero() {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  return (
    <div className="bg-cream">
      <Header />
      <section className="mx-auto flex max-w-[1280px] flex-col items-center gap-14 px-6 pb-24 pt-8 lg:flex-row lg:gap-[72px] lg:px-16 lg:pb-28 lg:pt-10">
        {/* Copy */}
        <div className="flex min-w-0 flex-1 flex-col gap-6 text-center lg:text-left">
          <div className="flex justify-center lg:justify-start">
            <span className="inline-flex items-center gap-2 rounded-full border-[1.5px] border-border_soft bg-surface px-4 py-2 text-[13px] font-semibold text-muted">
              <span className="h-2 w-2 rounded-full bg-[#7BAE85]" />
              {t("heroBadge")}
            </span>
          </div>
          <h1 className="text-[44px] font-bold leading-[1.06] tracking-[-1.5px] text-ink sm:text-[62px]">
            {t("heroTitle")}{" "}
            <span className="text-smg_orange">{t("heroTitleOrange")}</span>.
          </h1>
          <p className="mx-auto max-w-[460px] text-lg font-normal leading-relaxed text-muted lg:mx-0">
            {t("heroText")}
          </p>
          <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-center lg:justify-start">
            <a
              href={isAuthenticated ? t("loginLink") : t("signupLink")}
              className="ds-cta h-14 px-8 text-base"
            >
              {isAuthenticated ? t("goToApp") : t("startBtn")} →
            </a>
            <a
              href="/#pricing"
              className="text-[15px] font-semibold text-orange_deep transition-colors hover:text-orange_deeper hover:underline"
            >
              {t("heroSeePricing")}
            </a>
          </div>
          <div className="flex items-center justify-center gap-2.5 text-[13px] font-medium text-muted lg:justify-start">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M5 12.5 L10 17.5 L19 7" stroke="#7BAE85" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            {t("heroNoCard")}
          </div>
        </div>

        {/* Seat card */}
        <div className="flex min-w-0 flex-1 justify-center">
          <SeatCardWithBadge t={t} />
        </div>
      </section>
    </div>
  )
}

// Wrapper so the generated-in label reads from i18n
function SeatCardWithBadge({ t }) {
  const label = t("heroGeneratedIn")
  const rows = [0, 1, 2, 3]
  return (
    <div className="animate-floatBob rounded-[28px] bg-surface px-8 py-8 shadow-float sm:px-9">
      <div className="mx-auto mb-4 w-[170px]">
        <div className="flex h-8 items-center justify-center rounded-lg border-2 border-[#E5D8C8] bg-[#FDFCF9]">
          <span className="text-[8px] font-bold tracking-[2px] text-[#C9B79F]">BOARD</span>
        </div>
        <div className="mx-auto flex h-1.5 w-20 items-center justify-center gap-1 rounded-b bg-[#E5D8C8]">
          <span className="h-0.5 w-3 rounded-sm bg-[#E88B8B]" />
          <span className="h-0.5 w-3 rounded-sm bg-[#8FB4D9]" />
          <span className="h-0.5 w-3 rounded-sm bg-[#A9CDB0]" />
        </div>
      </div>
      <div className="flex flex-col gap-[11px]">
        {rows.map((r) => (
          <div key={r} className="flex justify-center gap-4">
            {[0, 1].map((c) => {
              const pair = names[r * 2 + c]
              return (
                <div key={c} className="flex h-10 w-[142px] gap-0.5 rounded-[10px] border border-deep bg-surface p-[3px]">
                  {pair.map((n, i) => {
                    const [bg, fg] = pastels[(r * 2 + c + i * 3) % pastels.length]
                    return (
                      <div key={i} style={{ background: bg, color: fg }} className="flex min-w-0 flex-1 items-center justify-center overflow-hidden whitespace-nowrap rounded-[7px] text-xs font-semibold">
                        {n}
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        ))}
      </div>
      <div className="mt-[18px] flex justify-center">
        <span className="flex items-center gap-[7px] rounded-full bg-tint px-3.5 py-[7px] text-xs font-semibold text-[#8C5A2E]">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <path d="M12 3 L14.5 9 L21 9.5 L16 13.8 L17.7 20 L12 16.5 L6.3 20 L8 13.8 L3 9.5 L9.5 9 Z" stroke="#FF6B01" strokeWidth="2" strokeLinejoin="round" />
          </svg>
          {label}
        </span>
      </div>
    </div>
  )
}
